import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingBottom: theme.spacing(4.5),
  },
}));

export default useStyles;
